import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Typography, Link } from '@mui/material';
import { usePartner } from './hooks/usePartner';
import { PartnerTable } from './PartnerTable';
import { CreatePartner } from './CreatePartner';
import { t } from 'i18next';
import { PartnerItem } from './components';
import HandshakeIcon from '@mui/icons-material/Handshake';
import { theme } from '@store';
import { ArrowBack } from '@mui/icons-material';

export const Partner = () => {
  const {
    totalCount,
    entries = [],
    isLoading,
    selectedPartnerId,
    handleCloseDrawer,
    handleOpenPartnerDetails,
    isDrawerOpen,
  } = usePartner();

  return (
    <>
      <Box
        sx={{
          cursor: 'pointer',
          [theme.breakpoints.down('md')]: {
            display: 'none',
          },
          width: 'fit-content',
        }}
      >
        <Link
          href={'/admin'}
          underline='always'
          sx={{
            display: 'flex',
            justifyContent: 'start',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          <ArrowBackIcon sx={{ fontSize: '1.5rem' }} color='primary' />
          <Typography sx={{ color: 'primary' }}>
            {t('general.backToPrevious')}
          </Typography>
        </Link>
      </Box>
      <Box
        sx={{
          paddingTop: '1rem',
          gap: '1rem',
          display: 'flex',
          flexDirection: 'column',
          pb: '1rem',
        }}
      >
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            <Box
              sx={{
                cursor: 'pointer',
                [theme.breakpoints.up('md')]: {
                  display: 'none',
                },
                width: 'fit-content',
              }}
            >
              <Link
                href={'/admin'}
                underline='always'
                sx={{
                  gap: 2,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start',
                }}
              >
                <ArrowBack
                  sx={{ fontSize: '2rem', color: 'rgba(0, 0, 0, 0.56)' }}
                  color='primary'
                />
              </Link>
            </Box>
            <Typography variant='h4'>
              {t('adminPanel.partners.title')}
            </Typography>
          </Box>

          <CreatePartner handleOpenPartnerDetails={handleOpenPartnerDetails} />
        </Box>
      </Box>
      {entries.length === 0 && !isLoading ? (
        <Box
          sx={{
            height: 'calc(100vh - 310px)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            gap: 1,
          }}
        >
          <HandshakeIcon
            sx={{ width: 56, height: 56, mb: 2 }}
            color='primary'
          />
          <Typography variant='h6'>
            {t('adminPanel.partners.noResults.title')}
          </Typography>
          <Typography variant='body2' sx={{ color: 'text.disabled' }}>
            {t('adminPanel.partners.noResults.subTitle')}
          </Typography>
        </Box>
      ) : (
        <PartnerTable
          rows={entries}
          totalCount={totalCount}
          onSelectPartner={handleOpenPartnerDetails}
          loading={isLoading}
          selectedRowId={selectedPartnerId}
        />
      )}
      {selectedPartnerId && (
        <PartnerItem
          open={isDrawerOpen}
          itemId={selectedPartnerId}
          handleClose={handleCloseDrawer}
        />
      )}
    </>
  );
};
